export default function getAllUsers(state) {
    return state.allUsers;
}